// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3qs_W","notFoundImage":"styles_notFoundImage__1BHTV","mainContent":"styles_mainContent__2rfkg","navigationBtn":"styles_navigationBtn__3OeXg"};